import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import commonEN from './locales/en/common.json';
import adminEN from './locales/en/admin.json';
import matchesEN from './locales/en/matches.json';
import authEN from './locales/en/auth.json';
import playersEN from './locales/en/players.json';
import organizationsEN from './locales/en/organizations.json';
import legalEn from './locales/en/legal.json';
import profileEN from './locales/en/profile.json';

import commonFI from './locales/fi/common.json';
import adminFI from './locales/fi/admin.json';
import matchesFI from './locales/fi/matches.json';
import authFI from './locales/fi/auth.json';
import playersFI from './locales/fi/players.json';
import organizationsFI from './locales/fi/organizations.json';
import legalFI from './locales/fi/legal.json';
import profileFI from './locales/fi/profile.json';

export const resources = {
  en: {
    common: commonEN,
    admin: adminEN,
    matches: matchesEN,
    auth: authEN,
    players: playersEN,
    organizations: organizationsEN,
    legal: legalEn,
    profile: profileEN,
  },
  fi: {
    common: commonFI,
    admin: adminFI,
    matches: matchesFI,
    auth: authFI,
    players: playersFI,
    organizations: organizationsFI,
    legal: legalFI,
    profile: profileFI,
  },
} as const;
export const defaultNS = 'matches';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    ns: ['common', 'admin', 'matches', 'auth', 'players', 'organizations', 'profile'],
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
      caches: [],
    },
  });

export default i18n;
export type Resources = typeof resources;
